import api from './ApiMiddleware';

const GetClientUserAssignments = (clientId) => {
  return api.get(`/api/v1/client/${clientId}/assignments/users`);
};

const GetClientUserGroupAssignments = (clientId) => {
  return api.get(`/api/v1/client/${clientId}/assignments/usergroups`);
};

const GetClientAssignmentsForUserGroup = (userGroupId) => {
  return api.get(`/api/x2/usergroups/${userGroupId}/clients`);
};

const AssignClientToUser = (clientId, userId) => {
  return api.post(`/api/v1/client/${clientId}/assign/user/${userId}`);
};

const UnassignClientFromUser = (clientId, userId) => {
  return api.put(`/api/v1/client/${clientId}/unassign/user/${userId}`);
};

const AssignClientToUserGroup = (clientId, userGroupId) => {
  return api.post(`/api/v1/client/${clientId}/assign/usergroup/${userGroupId}`);
};

const UnassignClientFromUserGroup = (clientId, userGroupId) => {
  return api.put(
    `/api/v1/client/${clientId}/unassign/usergroup/${userGroupId}`
  );
};

const UserClientAccessService = {
  GetClientUserAssignments,
  GetClientUserGroupAssignments,
  GetClientAssignmentsForUserGroup,
  AssignClientToUser,
  UnassignClientFromUser,
  AssignClientToUserGroup,
  UnassignClientFromUserGroup,
};

export default UserClientAccessService;
